import { FontAwesomeIcon, Props } from '@fortawesome/react-native-fontawesome';
import { StyleSheet } from 'react-native';

const icon_color = 'rgba(5, 22, 51, 0.5)';

export const FormRowIcon = (props: Props) => (
  <FontAwesomeIcon
    style={styles.icon}
    color={icon_color}
    size={22}
    {...props}
  />
);

const styles = StyleSheet.create({
  icon: {
    marginRight: 22,
  },
});
